import { render } from "./Secure.vue?vue&type=template&id=450ffbcb&scoped=true"
import script from "./Secure.vue?vue&type=script&lang=js"
export * from "./Secure.vue?vue&type=script&lang=js"

import "./Secure.vue?vue&type=style&index=0&id=450ffbcb&scoped=true&lang=css"

import exportComponent from "/home/admindb/web/crevent.pedasabis.com/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450ffbcb"]])

export default __exports__